import Home from "../views/Home";
import Operations from "../views/Operations";
import Enterprise from '../views/Enterprise';
import Analytics from '../views/Analytics';
import Account from '../views/Account';
import OrderView from "../views/Order";
import CreateOrder from "../views/CreateOrder";
import RecView from "../views/Rec";


export default [
    {
        path: ["/", "/home"],
        name: "Home",
        component: Home,
        exact: true
    },
    {
        path: "/operations",
        name: "Opérations",
        component: Operations,
        exact: true
    },
    {
        path: "/operations/:subkey",
        name: "Opérations",
        component: Operations,
        exact: true
    },
    {
        path: "/commande/:orderId",
        name: "Commande",
        component: OrderView,
        exact: true
    },
    {
        path: "/recurrence/:recId",
        name: "Recurrence",
        component: RecView,
        exact: true
    },
    {
        path: "/commander",
        name: "Commander",
        component: CreateOrder,
        exact: true
    },
    {
        path: "/entreprise",
        name: "Entreprise",
        component: Enterprise,
        exact: true
    },
    {
        path: "/entreprise/:subkey",
        name: "Entreprise",
        component: Enterprise,
        exact: true
    },
    {
        path: "/analytics",
        name: "Analytics",
        component: Analytics,
        exact: false
    },
    {
        path: "/mon-compte",
        name: "Mon compte",
        component: Account,
        exact: false
    }

];



// WEBPACK FOOTER //
// ./src/Utils/Routes.js